import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const STORAGE_KEY = "hns_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      // Migration: legacy cart items were missing merch_id; drop them so checkout doesn't fail
      return parsed.filter((p) => p && p.merch_id);
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = useCallback((product) => {
    setItems((prev) => {
      const found = prev.find((p) => p.id === product.id);
      if (found) return prev.map((p) => (p.id === product.id ? { ...p, qty: p.qty + 1 } : p));
      return [...prev, { ...product, qty: 1 }];
    });
    setOpen(true);
  }, []);

  const remove = useCallback((id) => setItems((prev) => prev.filter((p) => p.id !== id)), []);
  const setQty = useCallback((id, qty) => {
    setItems((prev) => prev.map((p) => (p.id === id ? { ...p, qty: Math.max(1, qty) } : p)).filter((p) => p.qty > 0));
  }, []);
  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((n, p) => n + p.qty, 0);
  const total = items.reduce((n, p) => n + p.qty * p.price, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, add, remove, setQty, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
};
